import { render } from "./OddBtn.vue?vue&type=template&id=37aef9e5&scoped=true"
import script from "./OddBtn.vue?vue&type=script&lang=js"
export * from "./OddBtn.vue?vue&type=script&lang=js"

import "./OddBtn.vue?vue&type=style&index=0&id=37aef9e5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aef9e5"]])

export default __exports__